/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AbstractCluster } from '../models/abstract-cluster';
import { DraftClusterRequest } from '../models/draft-cluster-request';
import { ImageOverrideRequest } from '../models/image-override-request';
import { AvailabilitySchedule } from '../models/availability-schedule';
import { ScheduleRequest } from '../models/schedule-request';
import { BranchUpdateRequest } from '../models/branch-update-request';
import { ClusterMetadata } from '../models/cluster-metadata';
import { CopyConfigurationsRequest } from '../models/copy-configurations-request';
import { SnapshotInfo } from '../models/snapshot-info';
import { ClusterResponse } from '../models/cluster-response';
import { KubernetesCredential } from '../models/kubernetes-credential';
import { MatchedModuleDTO } from '../models/matched-module-dto';
import { OverrideObject } from '../models/override-object';
import { OverrideRequest } from '../models/override-request';
import { PauseReleaseRequest } from '../models/pause-release-request';
import { ProvidedResources } from '../models/provided-resources';
import { ResourceEnableDisableRequest } from '../models/resource-enable-disable-request';
import { BlueprintFileSummaryDto } from '../models/blueprint-file-summary-dto';
import { ResourceDetails } from '../models/resource-details';
import { PageResourceReleaseImpact } from '../models/page-resource-release-impact';
import { ClusterSchedule } from '../models/cluster-schedule';
import { SilenceAlarmRequest } from '../models/silence-alarm-request';
import { StackTemplateInput } from '../models/stack-template-input';
import { TFRunConfigurations } from '../models/tfrun-configurations';
import { ToolsConfig } from '../models/tools-config';
import { VariableCountDto } from '../models/variable-count-dto';
import { Variables } from '../models/variables';

/**
 * Ui Common Cluster Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiCommonClusterControllerService extends __BaseService {
  static readonly createDraftClusterUsingPOSTPath =
    '/cc-ui/v1/clusters/draft-cluster';
  static readonly updateDraftClusterUsingPUTPath =
    '/cc-ui/v1/clusters/draft-cluster/{clusterId}';
  static readonly getNamespacesInUseByDependentClustersUsingGETPath =
    '/cc-ui/v1/clusters/{baseClusterId}/base-env-in-use-namespaces';
  static readonly getClusterCommonUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}';
  static readonly deleteClusterUsingDELETE1Path =
    '/cc-ui/v1/clusters/{clusterId}';
  static readonly getAlertsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/alerts';
  static readonly removeSilenceUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/alerts/silence/{silenceId}';
  static readonly attachImageUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/attach-image';
  static readonly getAvailabilitySchedulesUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/availability-schedule';
  static readonly createAvailabilityScheduleUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/availability-schedule';
  static readonly deleteAvailabilityScheduleUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/availability-schedule/{availabilityScheduleId}';
  static readonly updateAvailabilitySchedulesUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/availability-schedule/{scheduleId}';
  static readonly updateClusterBranchUsingPATCHPath =
    '/cc-ui/v1/clusters/{clusterId}/branch';
  static readonly getClusterMetadataUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/cluster-metadata';
  static readonly copyConfigurationsSelectiveUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/copy-configurations-selective';
  static readonly detachImageUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/detachImage';
  static readonly listSnapshotsUsingGET1Path =
    '/cc-ui/v1/clusters/{clusterId}/dr/{resourceType}/snapshots/{instanceName}';
  static readonly createSnapshotUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/dr/{resourceType}/snapshots/{instanceName}';
  static readonly getPinnedSnapshotUsingGET1Path =
    '/cc-ui/v1/clusters/{clusterId}/dr/{resourceType}/snapshots/{instanceName}/pinnedSnapshot';
  static readonly pinSnapshotUsingPOST1Path =
    '/cc-ui/v1/clusters/{clusterId}/dr/{resourceType}/snapshots/{instanceName}/pinnedSnapshot';
  static readonly deleteClusterForceUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/force';
  static readonly getClusterInfoUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/info';
  static readonly getK8sCredentialsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/k8sCredentials';
  static readonly getKubeConfigUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/kubeconfig';
  static readonly refreshKubeConfigUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/kubeconfig/refresh';
  static readonly getMatchedModulesUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/match-modules';
  static readonly getOpenAlertsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/open-alerts';
  static readonly getOverridesUsingGET1Path =
    '/cc-ui/v1/clusters/{clusterId}/overrides';
  static readonly overrideSizingUsingPOST1Path =
    '/cc-ui/v1/clusters/{clusterId}/overrides';
  static readonly deleteOverridesUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/overrides/{resourceType}/{resourceName}';
  static readonly pauseReleaseUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/pause-release';
  static readonly getProvidedResourcesUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/providedResources';
  static readonly upsertProvidedResourcesUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/providedResources';
  static readonly bulkEnableDisableResourcesUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/resource-enable-disable';
  static readonly getResourceStatsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/resource-stats';
  static readonly resourceDetailsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/resourceDetails';
  static readonly getReleaseImpactsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/resourceType/{resourceType}/resourceName/{resourceName}/release-impacts';
  static readonly getClusterSchedulesUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/schedule';
  static readonly addClusterSchedulesUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/schedule';
  static readonly updateClusterSchedulesUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/schedule/{clusterScheduleId}';
  static readonly deleteClusterScheduleUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/schedule/{clusterScheduleId}';
  static readonly setClusterCodeUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/setClusterCode';
  static readonly silenceAlertsUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/silence-alerts';
  static readonly getAllTemplateInputsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/templateInputs/';
  static readonly getTemplateInputsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/templateInputs/{inputType}/items';
  static readonly createTemplateInputsUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/templateInputs/{inputType}/items';
  static readonly getTemplateInputByUidUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/templateInputs/{inputType}/items/{uid}';
  static readonly updateTemplateInputUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/templateInputs/{inputType}/items/{uid}';
  static readonly deleteTemplateInputsUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/templateInputs/{inputType}/items/{uid}';
  static readonly getClusterTFDetailsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/tfRunConfigurations';
  static readonly createClusterTFDetailsUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/tfRunConfigurations';
  static readonly updateClusterTFDetailsUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/tfRunConfigurations';
  static readonly deleteClusterTFDetailsUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/tfRunConfigurations';
  static readonly getToolsConfigUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/tools-config';
  static readonly addToolsConfigUsingPOSTPath =
    '/cc-ui/v1/clusters/{clusterId}/tools-config';
  static readonly deleteToolsConfigUsingDELETEPath =
    '/cc-ui/v1/clusters/{clusterId}/tools-config';
  static readonly editToolsConfigUsingPUTPath =
    '/cc-ui/v1/clusters/{clusterId}/tools-config/{toolsConfigId}';
  static readonly getVariableCountsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/variable-counts';
  static readonly getVarsUsingGETPath = '/cc-ui/v1/clusters/{clusterId}/vars';
  static readonly getVarsWithSecretsUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/vars-with-secrets';
  static readonly upsertVarsUsingPOST1Path =
    '/cc-ui/v1/clusters/{clusterId}/vars/upsert';
  static readonly getVarsWithStatusUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/varsWithStatus';
  static readonly getVPNProfileUsingGETPath =
    '/cc-ui/v1/clusters/{clusterId}/vpn-profile';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * createDraftCluster
   * @param clusterRequest clusterRequest
   * @return OK
   */
  createDraftClusterUsingPOSTResponse(
    clusterRequest: DraftClusterRequest,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = clusterRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/clusters/draft-cluster`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * createDraftCluster
   * @param clusterRequest clusterRequest
   * @return OK
   */
  createDraftClusterUsingPOST(
    clusterRequest: DraftClusterRequest,
  ): __Observable<AbstractCluster> {
    return this.createDraftClusterUsingPOSTResponse(clusterRequest).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * updateDraftCluster
   * @param params The `UiCommonClusterControllerService.UpdateDraftClusterUsingPUTParams` containing the following parameters:
   *
   * - `clusterRequest`: clusterRequest
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateDraftClusterUsingPUTResponse(
    params: UiCommonClusterControllerService.UpdateDraftClusterUsingPUTParams,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.clusterRequest;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/draft-cluster/${encodeURIComponent(
          String(params.clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * updateDraftCluster
   * @param params The `UiCommonClusterControllerService.UpdateDraftClusterUsingPUTParams` containing the following parameters:
   *
   * - `clusterRequest`: clusterRequest
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateDraftClusterUsingPUT(
    params: UiCommonClusterControllerService.UpdateDraftClusterUsingPUTParams,
  ): __Observable<AbstractCluster> {
    return this.updateDraftClusterUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * getNamespacesInUseByDependentClusters
   * @param baseClusterId baseClusterId
   * @return OK
   */
  getNamespacesInUseByDependentClustersUsingGETResponse(
    baseClusterId: string,
  ): __Observable<__StrictHttpResponse<{ [key: string]: string }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(baseClusterId),
        )}/base-env-in-use-namespaces`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: string }>;
      }),
    );
  }
  /**
   * getNamespacesInUseByDependentClusters
   * @param baseClusterId baseClusterId
   * @return OK
   */
  getNamespacesInUseByDependentClustersUsingGET(
    baseClusterId: string,
  ): __Observable<{ [key: string]: string }> {
    return this.getNamespacesInUseByDependentClustersUsingGETResponse(
      baseClusterId,
    ).pipe(__map((_r) => _r.body as { [key: string]: string }));
  }

  /**
   * getClusterCommon
   * @param clusterId clusterId
   * @return OK
   */
  getClusterCommonUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * getClusterCommon
   * @param clusterId clusterId
   * @return OK
   */
  getClusterCommonUsingGET(clusterId: string): __Observable<AbstractCluster> {
    return this.getClusterCommonUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * deleteCluster
   * @param clusterId clusterId
   * @return OK
   */
  deleteClusterUsingDELETE1Response(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteCluster
   * @param clusterId clusterId
   * @return OK
   */
  deleteClusterUsingDELETE1(clusterId: string): __Observable<boolean> {
    return this.deleteClusterUsingDELETE1Response(clusterId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getAlerts
   * @param clusterId clusterId
   * @return OK
   */
  getAlertsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<{ [key: string]: {} }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}/alerts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: {} }>;
      }),
    );
  }
  /**
   * getAlerts
   * @param clusterId clusterId
   * @return OK
   */
  getAlertsUsingGET(clusterId: string): __Observable<{ [key: string]: {} }> {
    return this.getAlertsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as { [key: string]: {} }),
    );
  }

  /**
   * removeSilence
   * @param params The `UiCommonClusterControllerService.RemoveSilenceUsingDELETEParams` containing the following parameters:
   *
   * - `silenceId`: silenceId
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  removeSilenceUsingDELETEResponse(
    params: UiCommonClusterControllerService.RemoveSilenceUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<{ [key: string]: {} }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/alerts/silence/${encodeURIComponent(String(params.silenceId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: {} }>;
      }),
    );
  }
  /**
   * removeSilence
   * @param params The `UiCommonClusterControllerService.RemoveSilenceUsingDELETEParams` containing the following parameters:
   *
   * - `silenceId`: silenceId
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  removeSilenceUsingDELETE(
    params: UiCommonClusterControllerService.RemoveSilenceUsingDELETEParams,
  ): __Observable<{ [key: string]: {} }> {
    return this.removeSilenceUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as { [key: string]: {} }),
    );
  }

  /**
   * attachImage
   * @param params The `UiCommonClusterControllerService.AttachImageUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   */
  attachImageUsingPOSTResponse(
    params: UiCommonClusterControllerService.AttachImageUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/attach-image`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * attachImage
   * @param params The `UiCommonClusterControllerService.AttachImageUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   */
  attachImageUsingPOST(
    params: UiCommonClusterControllerService.AttachImageUsingPOSTParams,
  ): __Observable<null> {
    return this.attachImageUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getAvailabilitySchedules
   * @param clusterId clusterId
   * @return OK
   */
  getAvailabilitySchedulesUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<AvailabilitySchedule>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/availability-schedule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AvailabilitySchedule>;
      }),
    );
  }
  /**
   * getAvailabilitySchedules
   * @param clusterId clusterId
   * @return OK
   */
  getAvailabilitySchedulesUsingGET(
    clusterId: string,
  ): __Observable<AvailabilitySchedule> {
    return this.getAvailabilitySchedulesUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as AvailabilitySchedule),
    );
  }

  /**
   * createAvailabilitySchedule
   * @param params The `UiCommonClusterControllerService.CreateAvailabilityScheduleUsingPOSTParams` containing the following parameters:
   *
   * - `schedules`: schedules
   *
   * - `clusterId`: clusterId
   */
  createAvailabilityScheduleUsingPOSTResponse(
    params: UiCommonClusterControllerService.CreateAvailabilityScheduleUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.schedules;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/availability-schedule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * createAvailabilitySchedule
   * @param params The `UiCommonClusterControllerService.CreateAvailabilityScheduleUsingPOSTParams` containing the following parameters:
   *
   * - `schedules`: schedules
   *
   * - `clusterId`: clusterId
   */
  createAvailabilityScheduleUsingPOST(
    params: UiCommonClusterControllerService.CreateAvailabilityScheduleUsingPOSTParams,
  ): __Observable<null> {
    return this.createAvailabilityScheduleUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * deleteAvailabilitySchedule
   * @param params The `UiCommonClusterControllerService.DeleteAvailabilityScheduleUsingDELETEParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `availabilityScheduleId`: availabilityScheduleId
   */
  deleteAvailabilityScheduleUsingDELETEResponse(
    params: UiCommonClusterControllerService.DeleteAvailabilityScheduleUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/availability-schedule/${encodeURIComponent(
          String(params.availabilityScheduleId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteAvailabilitySchedule
   * @param params The `UiCommonClusterControllerService.DeleteAvailabilityScheduleUsingDELETEParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `availabilityScheduleId`: availabilityScheduleId
   */
  deleteAvailabilityScheduleUsingDELETE(
    params: UiCommonClusterControllerService.DeleteAvailabilityScheduleUsingDELETEParams,
  ): __Observable<null> {
    return this.deleteAvailabilityScheduleUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * updateAvailabilitySchedules
   * @param params The `UiCommonClusterControllerService.UpdateAvailabilitySchedulesUsingPUTParams` containing the following parameters:
   *
   * - `schedules`: schedules
   *
   * - `scheduleId`: scheduleId
   *
   * - `clusterId`: clusterId
   */
  updateAvailabilitySchedulesUsingPUTResponse(
    params: UiCommonClusterControllerService.UpdateAvailabilitySchedulesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.schedules;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/availability-schedule/${encodeURIComponent(
          String(params.scheduleId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * updateAvailabilitySchedules
   * @param params The `UiCommonClusterControllerService.UpdateAvailabilitySchedulesUsingPUTParams` containing the following parameters:
   *
   * - `schedules`: schedules
   *
   * - `scheduleId`: scheduleId
   *
   * - `clusterId`: clusterId
   */
  updateAvailabilitySchedulesUsingPUT(
    params: UiCommonClusterControllerService.UpdateAvailabilitySchedulesUsingPUTParams,
  ): __Observable<null> {
    return this.updateAvailabilitySchedulesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * updateClusterBranch
   * @param params The `UiCommonClusterControllerService.UpdateClusterBranchUsingPATCHParams` containing the following parameters:
   *
   * - `req`: req
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateClusterBranchUsingPATCHResponse(
    params: UiCommonClusterControllerService.UpdateClusterBranchUsingPATCHParams,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.req;

    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/branch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * updateClusterBranch
   * @param params The `UiCommonClusterControllerService.UpdateClusterBranchUsingPATCHParams` containing the following parameters:
   *
   * - `req`: req
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateClusterBranchUsingPATCH(
    params: UiCommonClusterControllerService.UpdateClusterBranchUsingPATCHParams,
  ): __Observable<AbstractCluster> {
    return this.updateClusterBranchUsingPATCHResponse(params).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * getClusterMetadata
   * @param clusterId clusterId
   * @return OK
   */
  getClusterMetadataUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<ClusterMetadata>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/cluster-metadata`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClusterMetadata>;
      }),
    );
  }
  /**
   * getClusterMetadata
   * @param clusterId clusterId
   * @return OK
   */
  getClusterMetadataUsingGET(clusterId: string): __Observable<ClusterMetadata> {
    return this.getClusterMetadataUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as ClusterMetadata),
    );
  }

  /**
   * Copy configurations from one cluster to another selectively
   *
   * Copies configurations from the source cluster to the target cluster. When mode is INCLUDE: Only specified configuration types are copied. When mode is EXCLUDE: All configuration types are copied except the specified ones.
   * @param params The `UiCommonClusterControllerService.CopyConfigurationsSelectiveUsingPUTParams` containing the following parameters:
   *
   * - `copyConfigurationsRequest`: Request containing source cluster ID, selection mode (INCLUDE/EXCLUDE), and set of configuration types
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  copyConfigurationsSelectiveUsingPUTResponse(
    params: UiCommonClusterControllerService.CopyConfigurationsSelectiveUsingPUTParams,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.copyConfigurationsRequest;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/copy-configurations-selective`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * Copy configurations from one cluster to another selectively
   *
   * Copies configurations from the source cluster to the target cluster. When mode is INCLUDE: Only specified configuration types are copied. When mode is EXCLUDE: All configuration types are copied except the specified ones.
   * @param params The `UiCommonClusterControllerService.CopyConfigurationsSelectiveUsingPUTParams` containing the following parameters:
   *
   * - `copyConfigurationsRequest`: Request containing source cluster ID, selection mode (INCLUDE/EXCLUDE), and set of configuration types
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  copyConfigurationsSelectiveUsingPUT(
    params: UiCommonClusterControllerService.CopyConfigurationsSelectiveUsingPUTParams,
  ): __Observable<AbstractCluster> {
    return this.copyConfigurationsSelectiveUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * detachImage
   * @param params The `UiCommonClusterControllerService.DetachImageUsingDELETEParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   */
  detachImageUsingDELETEResponse(
    params: UiCommonClusterControllerService.DetachImageUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/detachImage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * detachImage
   * @param params The `UiCommonClusterControllerService.DetachImageUsingDELETEParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   */
  detachImageUsingDELETE(
    params: UiCommonClusterControllerService.DetachImageUsingDELETEParams,
  ): __Observable<null> {
    return this.detachImageUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * listSnapshots
   * @param params The `UiCommonClusterControllerService.ListSnapshotsUsingGET1Params` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listSnapshotsUsingGET1Response(
    params: UiCommonClusterControllerService.ListSnapshotsUsingGET1Params,
  ): __Observable<__StrictHttpResponse<Array<SnapshotInfo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/dr/${encodeURIComponent(
          String(params.resourceType),
        )}/snapshots/${encodeURIComponent(String(params.instanceName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SnapshotInfo>>;
      }),
    );
  }
  /**
   * listSnapshots
   * @param params The `UiCommonClusterControllerService.ListSnapshotsUsingGET1Params` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  listSnapshotsUsingGET1(
    params: UiCommonClusterControllerService.ListSnapshotsUsingGET1Params,
  ): __Observable<Array<SnapshotInfo>> {
    return this.listSnapshotsUsingGET1Response(params).pipe(
      __map((_r) => _r.body as Array<SnapshotInfo>),
    );
  }

  /**
   * createSnapshot
   * @param params The `UiCommonClusterControllerService.CreateSnapshotUsingPOSTParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createSnapshotUsingPOSTResponse(
    params: UiCommonClusterControllerService.CreateSnapshotUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/dr/${encodeURIComponent(
          String(params.resourceType),
        )}/snapshots/${encodeURIComponent(String(params.instanceName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * createSnapshot
   * @param params The `UiCommonClusterControllerService.CreateSnapshotUsingPOSTParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createSnapshotUsingPOST(
    params: UiCommonClusterControllerService.CreateSnapshotUsingPOSTParams,
  ): __Observable<boolean> {
    return this.createSnapshotUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getPinnedSnapshot
   * @param params The `UiCommonClusterControllerService.GetPinnedSnapshotUsingGET1Params` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getPinnedSnapshotUsingGET1Response(
    params: UiCommonClusterControllerService.GetPinnedSnapshotUsingGET1Params,
  ): __Observable<__StrictHttpResponse<SnapshotInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/dr/${encodeURIComponent(
          String(params.resourceType),
        )}/snapshots/${encodeURIComponent(
          String(params.instanceName),
        )}/pinnedSnapshot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SnapshotInfo>;
      }),
    );
  }
  /**
   * getPinnedSnapshot
   * @param params The `UiCommonClusterControllerService.GetPinnedSnapshotUsingGET1Params` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getPinnedSnapshotUsingGET1(
    params: UiCommonClusterControllerService.GetPinnedSnapshotUsingGET1Params,
  ): __Observable<SnapshotInfo> {
    return this.getPinnedSnapshotUsingGET1Response(params).pipe(
      __map((_r) => _r.body as SnapshotInfo),
    );
  }

  /**
   * pinSnapshot
   * @param params The `UiCommonClusterControllerService.PinSnapshotUsingPOST1Params` containing the following parameters:
   *
   * - `snapshotInfo`: snapshotInfo
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  pinSnapshotUsingPOST1Response(
    params: UiCommonClusterControllerService.PinSnapshotUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<SnapshotInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.snapshotInfo;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/dr/${encodeURIComponent(
          String(params.resourceType),
        )}/snapshots/${encodeURIComponent(
          String(params.instanceName),
        )}/pinnedSnapshot`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SnapshotInfo>;
      }),
    );
  }
  /**
   * pinSnapshot
   * @param params The `UiCommonClusterControllerService.PinSnapshotUsingPOST1Params` containing the following parameters:
   *
   * - `snapshotInfo`: snapshotInfo
   *
   * - `resourceType`: resourceType
   *
   * - `instanceName`: instanceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  pinSnapshotUsingPOST1(
    params: UiCommonClusterControllerService.PinSnapshotUsingPOST1Params,
  ): __Observable<SnapshotInfo> {
    return this.pinSnapshotUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as SnapshotInfo),
    );
  }

  /**
   * deleteClusterForce
   * @param clusterId clusterId
   * @return OK
   */
  deleteClusterForceUsingDELETEResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}/force`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteClusterForce
   * @param clusterId clusterId
   * @return OK
   */
  deleteClusterForceUsingDELETE(clusterId: string): __Observable<boolean> {
    return this.deleteClusterForceUsingDELETEResponse(clusterId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getClusterInfo
   * @param clusterId clusterId
   * @return OK
   */
  getClusterInfoUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<ClusterResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}/info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClusterResponse>;
      }),
    );
  }
  /**
   * getClusterInfo
   * @param clusterId clusterId
   * @return OK
   */
  getClusterInfoUsingGET(clusterId: string): __Observable<ClusterResponse> {
    return this.getClusterInfoUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as ClusterResponse),
    );
  }

  /**
   * getK8sCredentials
   * @param params The `UiCommonClusterControllerService.GetK8sCredentialsUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `refreshPermissions`: refreshPermissions
   *
   * @return OK
   */
  getK8sCredentialsUsingGETResponse(
    params: UiCommonClusterControllerService.GetK8sCredentialsUsingGETParams,
  ): __Observable<__StrictHttpResponse<KubernetesCredential>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.refreshPermissions != null)
      __params = __params.set(
        'refreshPermissions',
        params.refreshPermissions.toString(),
      );
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/k8sCredentials`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KubernetesCredential>;
      }),
    );
  }
  /**
   * getK8sCredentials
   * @param params The `UiCommonClusterControllerService.GetK8sCredentialsUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `refreshPermissions`: refreshPermissions
   *
   * @return OK
   */
  getK8sCredentialsUsingGET(
    params: UiCommonClusterControllerService.GetK8sCredentialsUsingGETParams,
  ): __Observable<KubernetesCredential> {
    return this.getK8sCredentialsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as KubernetesCredential),
    );
  }

  /**
   * getKubeConfig
   * @param clusterId clusterId
   * @return OK
   */
  getKubeConfigUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/kubeconfig`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * getKubeConfig
   * @param clusterId clusterId
   * @return OK
   */
  getKubeConfigUsingGET(clusterId: string): __Observable<string> {
    return this.getKubeConfigUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as string),
    );
  }

  /**
   * refreshKubeConfig
   * @param clusterId clusterId
   * @return OK
   */
  refreshKubeConfigUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/kubeconfig/refresh`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * refreshKubeConfig
   * @param clusterId clusterId
   * @return OK
   */
  refreshKubeConfigUsingGET(clusterId: string): __Observable<boolean> {
    return this.refreshKubeConfigUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getMatchedModules
   * @param clusterId clusterId
   * @return OK
   */
  getMatchedModulesUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<MatchedModuleDTO>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/match-modules`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<MatchedModuleDTO>;
      }),
    );
  }
  /**
   * getMatchedModules
   * @param clusterId clusterId
   * @return OK
   */
  getMatchedModulesUsingGET(clusterId: string): __Observable<MatchedModuleDTO> {
    return this.getMatchedModulesUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as MatchedModuleDTO),
    );
  }

  /**
   * getOpenAlerts
   * @param clusterId clusterId
   * @return OK
   */
  getOpenAlertsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<{ [key: string]: {} }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/open-alerts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: {} }>;
      }),
    );
  }
  /**
   * getOpenAlerts
   * @param clusterId clusterId
   * @return OK
   */
  getOpenAlertsUsingGET(
    clusterId: string,
  ): __Observable<{ [key: string]: {} }> {
    return this.getOpenAlertsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as { [key: string]: {} }),
    );
  }

  /**
   * getOverrides
   * @param clusterId clusterId
   * @return OK
   */
  getOverridesUsingGET1Response(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<Array<OverrideObject>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}/overrides`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OverrideObject>>;
      }),
    );
  }
  /**
   * getOverrides
   * @param clusterId clusterId
   * @return OK
   */
  getOverridesUsingGET1(
    clusterId: string,
  ): __Observable<Array<OverrideObject>> {
    return this.getOverridesUsingGET1Response(clusterId).pipe(
      __map((_r) => _r.body as Array<OverrideObject>),
    );
  }

  /**
   * overrideSizing
   * @param params The `UiCommonClusterControllerService.OverrideSizingUsingPOST1Params` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  overrideSizingUsingPOST1Response(
    params: UiCommonClusterControllerService.OverrideSizingUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<Array<OverrideObject>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/overrides`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OverrideObject>>;
      }),
    );
  }
  /**
   * overrideSizing
   * @param params The `UiCommonClusterControllerService.OverrideSizingUsingPOST1Params` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  overrideSizingUsingPOST1(
    params: UiCommonClusterControllerService.OverrideSizingUsingPOST1Params,
  ): __Observable<Array<OverrideObject>> {
    return this.overrideSizingUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as Array<OverrideObject>),
    );
  }

  /**
   * deleteOverrides
   * @param params The `UiCommonClusterControllerService.DeleteOverridesUsingDELETEParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  deleteOverridesUsingDELETEResponse(
    params: UiCommonClusterControllerService.DeleteOverridesUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<Array<OverrideObject>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/overrides/${encodeURIComponent(
          String(params.resourceType),
        )}/${encodeURIComponent(String(params.resourceName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OverrideObject>>;
      }),
    );
  }
  /**
   * deleteOverrides
   * @param params The `UiCommonClusterControllerService.DeleteOverridesUsingDELETEParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  deleteOverridesUsingDELETE(
    params: UiCommonClusterControllerService.DeleteOverridesUsingDELETEParams,
  ): __Observable<Array<OverrideObject>> {
    return this.deleteOverridesUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as Array<OverrideObject>),
    );
  }

  /**
   * pauseRelease
   * @param params The `UiCommonClusterControllerService.PauseReleaseUsingPOSTParams` containing the following parameters:
   *
   * - `pauseReleaseRequest`: pauseReleaseRequest
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  pauseReleaseUsingPOSTResponse(
    params: UiCommonClusterControllerService.PauseReleaseUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.pauseReleaseRequest;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/pause-release`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * pauseRelease
   * @param params The `UiCommonClusterControllerService.PauseReleaseUsingPOSTParams` containing the following parameters:
   *
   * - `pauseReleaseRequest`: pauseReleaseRequest
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  pauseReleaseUsingPOST(
    params: UiCommonClusterControllerService.PauseReleaseUsingPOSTParams,
  ): __Observable<string> {
    return this.pauseReleaseUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as string),
    );
  }

  /**
   * getProvidedResources
   * @param clusterId clusterId
   * @return OK
   */
  getProvidedResourcesUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<ProvidedResources>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/providedResources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProvidedResources>;
      }),
    );
  }
  /**
   * getProvidedResources
   * @param clusterId clusterId
   * @return OK
   */
  getProvidedResourcesUsingGET(
    clusterId: string,
  ): __Observable<ProvidedResources> {
    return this.getProvidedResourcesUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as ProvidedResources),
    );
  }

  /**
   * upsertProvidedResources
   * @param params The `UiCommonClusterControllerService.UpsertProvidedResourcesUsingPOSTParams` containing the following parameters:
   *
   * - `providedResources`: providedResources
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  upsertProvidedResourcesUsingPOSTResponse(
    params: UiCommonClusterControllerService.UpsertProvidedResourcesUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ProvidedResources>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.providedResources;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/providedResources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProvidedResources>;
      }),
    );
  }
  /**
   * upsertProvidedResources
   * @param params The `UiCommonClusterControllerService.UpsertProvidedResourcesUsingPOSTParams` containing the following parameters:
   *
   * - `providedResources`: providedResources
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  upsertProvidedResourcesUsingPOST(
    params: UiCommonClusterControllerService.UpsertProvidedResourcesUsingPOSTParams,
  ): __Observable<ProvidedResources> {
    return this.upsertProvidedResourcesUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ProvidedResources),
    );
  }

  /**
   * bulkEnableDisableResources
   * @param params The `UiCommonClusterControllerService.BulkEnableDisableResourcesUsingPUTParams` containing the following parameters:
   *
   * - `resourceEnableDisableRequestList`: resourceEnableDisableRequestList
   *
   * - `clusterId`: clusterId
   */
  bulkEnableDisableResourcesUsingPUTResponse(
    params: UiCommonClusterControllerService.BulkEnableDisableResourcesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.resourceEnableDisableRequestList;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/resource-enable-disable`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * bulkEnableDisableResources
   * @param params The `UiCommonClusterControllerService.BulkEnableDisableResourcesUsingPUTParams` containing the following parameters:
   *
   * - `resourceEnableDisableRequestList`: resourceEnableDisableRequestList
   *
   * - `clusterId`: clusterId
   */
  bulkEnableDisableResourcesUsingPUT(
    params: UiCommonClusterControllerService.BulkEnableDisableResourcesUsingPUTParams,
  ): __Observable<null> {
    return this.bulkEnableDisableResourcesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getResourceStats
   * @param clusterId clusterId
   * @return OK
   */
  getResourceStatsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<BlueprintFileSummaryDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/resource-stats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BlueprintFileSummaryDto>;
      }),
    );
  }
  /**
   * getResourceStats
   * @param clusterId clusterId
   * @return OK
   */
  getResourceStatsUsingGET(
    clusterId: string,
  ): __Observable<BlueprintFileSummaryDto> {
    return this.getResourceStatsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as BlueprintFileSummaryDto),
    );
  }

  /**
   * resourceDetails
   * @param clusterId clusterId
   * @return OK
   */
  resourceDetailsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<Array<ResourceDetails>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/resourceDetails`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResourceDetails>>;
      }),
    );
  }
  /**
   * resourceDetails
   * @param clusterId clusterId
   * @return OK
   */
  resourceDetailsUsingGET(
    clusterId: string,
  ): __Observable<Array<ResourceDetails>> {
    return this.resourceDetailsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as Array<ResourceDetails>),
    );
  }

  /**
   * getReleaseImpacts
   * @param params The `UiCommonClusterControllerService.GetReleaseImpactsUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * - `triggeredBy`: triggeredBy
   *
   * - `start`: start
   *
   * - `releaseType`: releaseType
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `end`: end
   *
   * - `changeType`: changeType
   *
   * - `attribute`: attribute
   *
   * @return OK
   */
  getReleaseImpactsUsingGETResponse(
    params: UiCommonClusterControllerService.GetReleaseImpactsUsingGETParams,
  ): __Observable<__StrictHttpResponse<PageResourceReleaseImpact>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.triggeredBy != null)
      __params = __params.set('triggeredBy', params.triggeredBy.toString());
    if (params.start != null)
      __params = __params.set('start', params.start.toString());
    if (params.releaseType != null)
      __params = __params.set('releaseType', params.releaseType.toString());
    if (params.pageSize != null)
      __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null)
      __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.end != null)
      __params = __params.set('end', params.end.toString());
    if (params.changeType != null)
      __params = __params.set('changeType', params.changeType.toString());
    if (params.attribute != null)
      __params = __params.set('attribute', params.attribute.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/release-impacts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PageResourceReleaseImpact>;
      }),
    );
  }
  /**
   * getReleaseImpacts
   * @param params The `UiCommonClusterControllerService.GetReleaseImpactsUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * - `triggeredBy`: triggeredBy
   *
   * - `start`: start
   *
   * - `releaseType`: releaseType
   *
   * - `pageSize`: pageSize
   *
   * - `pageNumber`: pageNumber
   *
   * - `end`: end
   *
   * - `changeType`: changeType
   *
   * - `attribute`: attribute
   *
   * @return OK
   */
  getReleaseImpactsUsingGET(
    params: UiCommonClusterControllerService.GetReleaseImpactsUsingGETParams,
  ): __Observable<PageResourceReleaseImpact> {
    return this.getReleaseImpactsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as PageResourceReleaseImpact),
    );
  }

  /**
   * getClusterSchedules
   * @param clusterId clusterId
   * @return OK
   */
  getClusterSchedulesUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<Array<ClusterSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}/schedule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterSchedule>>;
      }),
    );
  }
  /**
   * getClusterSchedules
   * @param clusterId clusterId
   * @return OK
   */
  getClusterSchedulesUsingGET(
    clusterId: string,
  ): __Observable<Array<ClusterSchedule>> {
    return this.getClusterSchedulesUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as Array<ClusterSchedule>),
    );
  }

  /**
   * addClusterSchedules
   * @param params The `UiCommonClusterControllerService.AddClusterSchedulesUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  addClusterSchedulesUsingPOSTResponse(
    params: UiCommonClusterControllerService.AddClusterSchedulesUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<Array<ClusterSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/schedule`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterSchedule>>;
      }),
    );
  }
  /**
   * addClusterSchedules
   * @param params The `UiCommonClusterControllerService.AddClusterSchedulesUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  addClusterSchedulesUsingPOST(
    params: UiCommonClusterControllerService.AddClusterSchedulesUsingPOSTParams,
  ): __Observable<Array<ClusterSchedule>> {
    return this.addClusterSchedulesUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as Array<ClusterSchedule>),
    );
  }

  /**
   * updateClusterSchedules
   * @param params The `UiCommonClusterControllerService.UpdateClusterSchedulesUsingPUTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterScheduleId`: clusterScheduleId
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateClusterSchedulesUsingPUTResponse(
    params: UiCommonClusterControllerService.UpdateClusterSchedulesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<Array<ClusterSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/schedule/${encodeURIComponent(String(params.clusterScheduleId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterSchedule>>;
      }),
    );
  }
  /**
   * updateClusterSchedules
   * @param params The `UiCommonClusterControllerService.UpdateClusterSchedulesUsingPUTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterScheduleId`: clusterScheduleId
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateClusterSchedulesUsingPUT(
    params: UiCommonClusterControllerService.UpdateClusterSchedulesUsingPUTParams,
  ): __Observable<Array<ClusterSchedule>> {
    return this.updateClusterSchedulesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as Array<ClusterSchedule>),
    );
  }

  /**
   * deleteClusterSchedule
   * @param params The `UiCommonClusterControllerService.DeleteClusterScheduleUsingDELETEParams` containing the following parameters:
   *
   * - `clusterScheduleId`: clusterScheduleId
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  deleteClusterScheduleUsingDELETEResponse(
    params: UiCommonClusterControllerService.DeleteClusterScheduleUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<Array<ClusterSchedule>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/schedule/${encodeURIComponent(String(params.clusterScheduleId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterSchedule>>;
      }),
    );
  }
  /**
   * deleteClusterSchedule
   * @param params The `UiCommonClusterControllerService.DeleteClusterScheduleUsingDELETEParams` containing the following parameters:
   *
   * - `clusterScheduleId`: clusterScheduleId
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  deleteClusterScheduleUsingDELETE(
    params: UiCommonClusterControllerService.DeleteClusterScheduleUsingDELETEParams,
  ): __Observable<Array<ClusterSchedule>> {
    return this.deleteClusterScheduleUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as Array<ClusterSchedule>),
    );
  }

  /**
   * setClusterCode
   * @param clusterId clusterId
   * @return OK
   */
  setClusterCodeUsingPOSTResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/setClusterCode`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * setClusterCode
   * @param clusterId clusterId
   * @return OK
   */
  setClusterCodeUsingPOST(clusterId: string): __Observable<boolean> {
    return this.setClusterCodeUsingPOSTResponse(clusterId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * silenceAlerts
   * @param params The `UiCommonClusterControllerService.SilenceAlertsUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  silenceAlertsUsingPOSTResponse(
    params: UiCommonClusterControllerService.SilenceAlertsUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<{ [key: string]: {} }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/silence-alerts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: {} }>;
      }),
    );
  }
  /**
   * silenceAlerts
   * @param params The `UiCommonClusterControllerService.SilenceAlertsUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  silenceAlertsUsingPOST(
    params: UiCommonClusterControllerService.SilenceAlertsUsingPOSTParams,
  ): __Observable<{ [key: string]: {} }> {
    return this.silenceAlertsUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as { [key: string]: {} }),
    );
  }

  /**
   * getAllTemplateInputs
   * @param clusterId clusterId
   * @return OK
   */
  getAllTemplateInputsUsingGETResponse(
    clusterId: string,
  ): __Observable<
    __StrictHttpResponse<{ [key: string]: Array<StackTemplateInput> }>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/templateInputs/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{
          [key: string]: Array<StackTemplateInput>;
        }>;
      }),
    );
  }
  /**
   * getAllTemplateInputs
   * @param clusterId clusterId
   * @return OK
   */
  getAllTemplateInputsUsingGET(
    clusterId: string,
  ): __Observable<{ [key: string]: Array<StackTemplateInput> }> {
    return this.getAllTemplateInputsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as { [key: string]: Array<StackTemplateInput> }),
    );
  }

  /**
   * getTemplateInputs
   * @param params The `UiCommonClusterControllerService.GetTemplateInputsUsingGETParams` containing the following parameters:
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getTemplateInputsUsingGETResponse(
    params: UiCommonClusterControllerService.GetTemplateInputsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<StackTemplateInput>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/templateInputs/${encodeURIComponent(
          String(params.inputType),
        )}/items`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<StackTemplateInput>>;
      }),
    );
  }
  /**
   * getTemplateInputs
   * @param params The `UiCommonClusterControllerService.GetTemplateInputsUsingGETParams` containing the following parameters:
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getTemplateInputsUsingGET(
    params: UiCommonClusterControllerService.GetTemplateInputsUsingGETParams,
  ): __Observable<Array<StackTemplateInput>> {
    return this.getTemplateInputsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<StackTemplateInput>),
    );
  }

  /**
   * createTemplateInputs
   * @param params The `UiCommonClusterControllerService.CreateTemplateInputsUsingPOSTParams` containing the following parameters:
   *
   * - `templateInputs`: templateInputs
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createTemplateInputsUsingPOSTResponse(
    params: UiCommonClusterControllerService.CreateTemplateInputsUsingPOSTParams,
  ): __Observable<
    __StrictHttpResponse<{ [key: string]: Array<StackTemplateInput> }>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.templateInputs;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/templateInputs/${encodeURIComponent(
          String(params.inputType),
        )}/items`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{
          [key: string]: Array<StackTemplateInput>;
        }>;
      }),
    );
  }
  /**
   * createTemplateInputs
   * @param params The `UiCommonClusterControllerService.CreateTemplateInputsUsingPOSTParams` containing the following parameters:
   *
   * - `templateInputs`: templateInputs
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createTemplateInputsUsingPOST(
    params: UiCommonClusterControllerService.CreateTemplateInputsUsingPOSTParams,
  ): __Observable<{ [key: string]: Array<StackTemplateInput> }> {
    return this.createTemplateInputsUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as { [key: string]: Array<StackTemplateInput> }),
    );
  }

  /**
   * getTemplateInputByUid
   * @param params The `UiCommonClusterControllerService.GetTemplateInputByUidUsingGETParams` containing the following parameters:
   *
   * - `uid`: uid
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getTemplateInputByUidUsingGETResponse(
    params: UiCommonClusterControllerService.GetTemplateInputByUidUsingGETParams,
  ): __Observable<__StrictHttpResponse<StackTemplateInput>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/templateInputs/${encodeURIComponent(
          String(params.inputType),
        )}/items/${encodeURIComponent(String(params.uid))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StackTemplateInput>;
      }),
    );
  }
  /**
   * getTemplateInputByUid
   * @param params The `UiCommonClusterControllerService.GetTemplateInputByUidUsingGETParams` containing the following parameters:
   *
   * - `uid`: uid
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getTemplateInputByUidUsingGET(
    params: UiCommonClusterControllerService.GetTemplateInputByUidUsingGETParams,
  ): __Observable<StackTemplateInput> {
    return this.getTemplateInputByUidUsingGETResponse(params).pipe(
      __map((_r) => _r.body as StackTemplateInput),
    );
  }

  /**
   * updateTemplateInput
   * @param params The `UiCommonClusterControllerService.UpdateTemplateInputUsingPUTParams` containing the following parameters:
   *
   * - `uid`: uid
   *
   * - `templateInput`: templateInput
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateTemplateInputUsingPUTResponse(
    params: UiCommonClusterControllerService.UpdateTemplateInputUsingPUTParams,
  ): __Observable<__StrictHttpResponse<StackTemplateInput>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.templateInput;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/templateInputs/${encodeURIComponent(
          String(params.inputType),
        )}/items/${encodeURIComponent(String(params.uid))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StackTemplateInput>;
      }),
    );
  }
  /**
   * updateTemplateInput
   * @param params The `UiCommonClusterControllerService.UpdateTemplateInputUsingPUTParams` containing the following parameters:
   *
   * - `uid`: uid
   *
   * - `templateInput`: templateInput
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateTemplateInputUsingPUT(
    params: UiCommonClusterControllerService.UpdateTemplateInputUsingPUTParams,
  ): __Observable<StackTemplateInput> {
    return this.updateTemplateInputUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as StackTemplateInput),
    );
  }

  /**
   * deleteTemplateInputs
   * @param params The `UiCommonClusterControllerService.DeleteTemplateInputsUsingDELETEParams` containing the following parameters:
   *
   * - `uid`: uid
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  deleteTemplateInputsUsingDELETEResponse(
    params: UiCommonClusterControllerService.DeleteTemplateInputsUsingDELETEParams,
  ): __Observable<__StrictHttpResponse<StackTemplateInput>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/templateInputs/${encodeURIComponent(
          String(params.inputType),
        )}/items/${encodeURIComponent(String(params.uid))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StackTemplateInput>;
      }),
    );
  }
  /**
   * deleteTemplateInputs
   * @param params The `UiCommonClusterControllerService.DeleteTemplateInputsUsingDELETEParams` containing the following parameters:
   *
   * - `uid`: uid
   *
   * - `inputType`: inputType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  deleteTemplateInputsUsingDELETE(
    params: UiCommonClusterControllerService.DeleteTemplateInputsUsingDELETEParams,
  ): __Observable<StackTemplateInput> {
    return this.deleteTemplateInputsUsingDELETEResponse(params).pipe(
      __map((_r) => _r.body as StackTemplateInput),
    );
  }

  /**
   * getClusterTFDetails
   * @param clusterId clusterId
   * @return OK
   */
  getClusterTFDetailsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<TFRunConfigurations>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/tfRunConfigurations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TFRunConfigurations>;
      }),
    );
  }
  /**
   * getClusterTFDetails
   * @param clusterId clusterId
   * @return OK
   */
  getClusterTFDetailsUsingGET(
    clusterId: string,
  ): __Observable<TFRunConfigurations> {
    return this.getClusterTFDetailsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as TFRunConfigurations),
    );
  }

  /**
   * createClusterTFDetails
   * @param params The `UiCommonClusterControllerService.CreateClusterTFDetailsUsingPOSTParams` containing the following parameters:
   *
   * - `tfRunConfigurations`: tfRunConfigurations
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createClusterTFDetailsUsingPOSTResponse(
    params: UiCommonClusterControllerService.CreateClusterTFDetailsUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<TFRunConfigurations>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.tfRunConfigurations;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/tfRunConfigurations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TFRunConfigurations>;
      }),
    );
  }
  /**
   * createClusterTFDetails
   * @param params The `UiCommonClusterControllerService.CreateClusterTFDetailsUsingPOSTParams` containing the following parameters:
   *
   * - `tfRunConfigurations`: tfRunConfigurations
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  createClusterTFDetailsUsingPOST(
    params: UiCommonClusterControllerService.CreateClusterTFDetailsUsingPOSTParams,
  ): __Observable<TFRunConfigurations> {
    return this.createClusterTFDetailsUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as TFRunConfigurations),
    );
  }

  /**
   * updateClusterTFDetails
   * @param params The `UiCommonClusterControllerService.UpdateClusterTFDetailsUsingPUTParams` containing the following parameters:
   *
   * - `tfRunConfigurations`: tfRunConfigurations
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateClusterTFDetailsUsingPUTResponse(
    params: UiCommonClusterControllerService.UpdateClusterTFDetailsUsingPUTParams,
  ): __Observable<__StrictHttpResponse<TFRunConfigurations>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.tfRunConfigurations;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/tfRunConfigurations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TFRunConfigurations>;
      }),
    );
  }
  /**
   * updateClusterTFDetails
   * @param params The `UiCommonClusterControllerService.UpdateClusterTFDetailsUsingPUTParams` containing the following parameters:
   *
   * - `tfRunConfigurations`: tfRunConfigurations
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  updateClusterTFDetailsUsingPUT(
    params: UiCommonClusterControllerService.UpdateClusterTFDetailsUsingPUTParams,
  ): __Observable<TFRunConfigurations> {
    return this.updateClusterTFDetailsUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as TFRunConfigurations),
    );
  }

  /**
   * deleteClusterTFDetails
   * @param clusterId clusterId
   * @return OK
   */
  deleteClusterTFDetailsUsingDELETEResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<TFRunConfigurations>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/tfRunConfigurations`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TFRunConfigurations>;
      }),
    );
  }
  /**
   * deleteClusterTFDetails
   * @param clusterId clusterId
   * @return OK
   */
  deleteClusterTFDetailsUsingDELETE(
    clusterId: string,
  ): __Observable<TFRunConfigurations> {
    return this.deleteClusterTFDetailsUsingDELETEResponse(clusterId).pipe(
      __map((_r) => _r.body as TFRunConfigurations),
    );
  }

  /**
   * getToolsConfig
   * @param clusterId clusterId
   * @return OK
   */
  getToolsConfigUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<ToolsConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/tools-config`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ToolsConfig>;
      }),
    );
  }
  /**
   * getToolsConfig
   * @param clusterId clusterId
   * @return OK
   */
  getToolsConfigUsingGET(clusterId: string): __Observable<ToolsConfig> {
    return this.getToolsConfigUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as ToolsConfig),
    );
  }

  /**
   * addToolsConfig
   * @param params The `UiCommonClusterControllerService.AddToolsConfigUsingPOSTParams` containing the following parameters:
   *
   * - `toolsConfig`: toolsConfig
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  addToolsConfigUsingPOSTResponse(
    params: UiCommonClusterControllerService.AddToolsConfigUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ToolsConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.toolsConfig;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/tools-config`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ToolsConfig>;
      }),
    );
  }
  /**
   * addToolsConfig
   * @param params The `UiCommonClusterControllerService.AddToolsConfigUsingPOSTParams` containing the following parameters:
   *
   * - `toolsConfig`: toolsConfig
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  addToolsConfigUsingPOST(
    params: UiCommonClusterControllerService.AddToolsConfigUsingPOSTParams,
  ): __Observable<ToolsConfig> {
    return this.addToolsConfigUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ToolsConfig),
    );
  }

  /**
   * deleteToolsConfig
   * @param clusterId clusterId
   */
  deleteToolsConfigUsingDELETEResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/tools-config`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * deleteToolsConfig
   * @param clusterId clusterId
   */
  deleteToolsConfigUsingDELETE(clusterId: string): __Observable<null> {
    return this.deleteToolsConfigUsingDELETEResponse(clusterId).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * editToolsConfig
   * @param params The `UiCommonClusterControllerService.EditToolsConfigUsingPUTParams` containing the following parameters:
   *
   * - `toolsConfigId`: toolsConfigId
   *
   * - `toolsConfig`: toolsConfig
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  editToolsConfigUsingPUTResponse(
    params: UiCommonClusterControllerService.EditToolsConfigUsingPUTParams,
  ): __Observable<__StrictHttpResponse<ToolsConfig>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.toolsConfig;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/tools-config/${encodeURIComponent(String(params.toolsConfigId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ToolsConfig>;
      }),
    );
  }
  /**
   * editToolsConfig
   * @param params The `UiCommonClusterControllerService.EditToolsConfigUsingPUTParams` containing the following parameters:
   *
   * - `toolsConfigId`: toolsConfigId
   *
   * - `toolsConfig`: toolsConfig
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  editToolsConfigUsingPUT(
    params: UiCommonClusterControllerService.EditToolsConfigUsingPUTParams,
  ): __Observable<ToolsConfig> {
    return this.editToolsConfigUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as ToolsConfig),
    );
  }

  /**
   * getVariableCounts
   * @param clusterId clusterId
   * @return OK
   */
  getVariableCountsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<VariableCountDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/variable-counts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VariableCountDto>;
      }),
    );
  }
  /**
   * getVariableCounts
   * @param clusterId clusterId
   * @return OK
   */
  getVariableCountsUsingGET(clusterId: string): __Observable<VariableCountDto> {
    return this.getVariableCountsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as VariableCountDto),
    );
  }

  /**
   * getVars
   * @param clusterId clusterId
   * @return OK
   */
  getVarsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(String(clusterId))}/vars`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * getVars
   * @param clusterId clusterId
   * @return OK
   */
  getVarsUsingGET(clusterId: string): __Observable<AbstractCluster> {
    return this.getVarsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * getVarsWithSecrets
   * @param clusterId clusterId
   * @return OK
   */
  getVarsWithSecretsUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/vars-with-secrets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * getVarsWithSecrets
   * @param clusterId clusterId
   * @return OK
   */
  getVarsWithSecretsUsingGET(clusterId: string): __Observable<AbstractCluster> {
    return this.getVarsWithSecretsUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * upsertVars
   * @param params The `UiCommonClusterControllerService.UpsertVarsUsingPOST1Params` containing the following parameters:
   *
   * - `clusterVars`: clusterVars
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  upsertVarsUsingPOST1Response(
    params: UiCommonClusterControllerService.UpsertVarsUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<AbstractCluster>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.clusterVars;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(params.clusterId),
        )}/vars/upsert`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AbstractCluster>;
      }),
    );
  }
  /**
   * upsertVars
   * @param params The `UiCommonClusterControllerService.UpsertVarsUsingPOST1Params` containing the following parameters:
   *
   * - `clusterVars`: clusterVars
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  upsertVarsUsingPOST1(
    params: UiCommonClusterControllerService.UpsertVarsUsingPOST1Params,
  ): __Observable<AbstractCluster> {
    return this.upsertVarsUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as AbstractCluster),
    );
  }

  /**
   * getVarsWithStatus
   * @param clusterId clusterId
   * @return OK
   */
  getVarsWithStatusUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<{ [key: string]: Variables }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/varsWithStatus`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: Variables }>;
      }),
    );
  }
  /**
   * getVarsWithStatus
   * @param clusterId clusterId
   * @return OK
   */
  getVarsWithStatusUsingGET(
    clusterId: string,
  ): __Observable<{ [key: string]: Variables }> {
    return this.getVarsWithStatusUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as { [key: string]: Variables }),
    );
  }

  /**
   * getVPNProfile
   * @param clusterId clusterId
   * @return OK
   */
  getVPNProfileUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/clusters/${encodeURIComponent(
          String(clusterId),
        )}/vpn-profile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      }),
    );
  }
  /**
   * getVPNProfile
   * @param clusterId clusterId
   * @return OK
   */
  getVPNProfileUsingGET(clusterId: string): __Observable<string> {
    return this.getVPNProfileUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as string),
    );
  }
}

module UiCommonClusterControllerService {
  /**
   * Parameters for updateDraftClusterUsingPUT
   */
  export interface UpdateDraftClusterUsingPUTParams {
    /**
     * clusterRequest
     */
    clusterRequest: DraftClusterRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for removeSilenceUsingDELETE
   */
  export interface RemoveSilenceUsingDELETEParams {
    /**
     * silenceId
     */
    silenceId: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for attachImageUsingPOST
   */
  export interface AttachImageUsingPOSTParams {
    /**
     * request
     */
    request: ImageOverrideRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for createAvailabilityScheduleUsingPOST
   */
  export interface CreateAvailabilityScheduleUsingPOSTParams {
    /**
     * schedules
     */
    schedules: Array<ScheduleRequest>;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for deleteAvailabilityScheduleUsingDELETE
   */
  export interface DeleteAvailabilityScheduleUsingDELETEParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * availabilityScheduleId
     */
    availabilityScheduleId: string;
  }

  /**
   * Parameters for updateAvailabilitySchedulesUsingPUT
   */
  export interface UpdateAvailabilitySchedulesUsingPUTParams {
    /**
     * schedules
     */
    schedules: Array<ScheduleRequest>;

    /**
     * scheduleId
     */
    scheduleId: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for updateClusterBranchUsingPATCH
   */
  export interface UpdateClusterBranchUsingPATCHParams {
    /**
     * req
     */
    req: BranchUpdateRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for copyConfigurationsSelectiveUsingPUT
   */
  export interface CopyConfigurationsSelectiveUsingPUTParams {
    /**
     * Request containing source cluster ID, selection mode (INCLUDE/EXCLUDE), and set of configuration types
     */
    copyConfigurationsRequest: CopyConfigurationsRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for detachImageUsingDELETE
   */
  export interface DetachImageUsingDELETEParams {
    /**
     * request
     */
    request: ImageOverrideRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for listSnapshotsUsingGET1
   */
  export interface ListSnapshotsUsingGET1Params {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * instanceName
     */
    instanceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for createSnapshotUsingPOST
   */
  export interface CreateSnapshotUsingPOSTParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * instanceName
     */
    instanceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getPinnedSnapshotUsingGET1
   */
  export interface GetPinnedSnapshotUsingGET1Params {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * instanceName
     */
    instanceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for pinSnapshotUsingPOST1
   */
  export interface PinSnapshotUsingPOST1Params {
    /**
     * snapshotInfo
     */
    snapshotInfo: SnapshotInfo;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * instanceName
     */
    instanceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getK8sCredentialsUsingGET
   */
  export interface GetK8sCredentialsUsingGETParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * refreshPermissions
     */
    refreshPermissions?: boolean;
  }

  /**
   * Parameters for overrideSizingUsingPOST1
   */
  export interface OverrideSizingUsingPOST1Params {
    /**
     * request
     */
    request: Array<OverrideRequest>;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for deleteOverridesUsingDELETE
   */
  export interface DeleteOverridesUsingDELETEParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for pauseReleaseUsingPOST
   */
  export interface PauseReleaseUsingPOSTParams {
    /**
     * pauseReleaseRequest
     */
    pauseReleaseRequest: PauseReleaseRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for upsertProvidedResourcesUsingPOST
   */
  export interface UpsertProvidedResourcesUsingPOSTParams {
    /**
     * providedResources
     */
    providedResources: ProvidedResources;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for bulkEnableDisableResourcesUsingPUT
   */
  export interface BulkEnableDisableResourcesUsingPUTParams {
    /**
     * resourceEnableDisableRequestList
     */
    resourceEnableDisableRequestList: Array<ResourceEnableDisableRequest>;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getReleaseImpactsUsingGET
   */
  export interface GetReleaseImpactsUsingGETParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * clusterId
     */
    clusterId: string;

    /**
     * triggeredBy
     */
    triggeredBy?: string;

    /**
     * start
     */
    start?: string;

    /**
     * releaseType
     */
    releaseType?:
      | 'HOTFIX'
      | 'RELEASE'
      | 'LAUNCH'
      | 'DESTROY'
      | 'CUSTOM'
      | 'UNLOCK_STATE'
      | 'PLAN'
      | 'HOTFIX_PLAN'
      | 'APPLY_PLAN'
      | 'APPLY_HOTFIX_PLAN'
      | 'SCALE_UP'
      | 'SCALE_DOWN'
      | 'MAINTENANCE'
      | 'TERRAFORM_EXPORT'
      | 'ROLLBACK_PLAN'
      | 'APPLY_ROLLBACK_PLAN';

    /**
     * pageSize
     */
    pageSize?: number;

    /**
     * pageNumber
     */
    pageNumber?: number;

    /**
     * end
     */
    end?: string;

    /**
     * changeType
     */
    changeType?: 'ADDED' | 'MODIFIED' | 'REMOVED';

    /**
     * attribute
     */
    attribute?: string;
  }

  /**
   * Parameters for addClusterSchedulesUsingPOST
   */
  export interface AddClusterSchedulesUsingPOSTParams {
    /**
     * request
     */
    request: ScheduleRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for updateClusterSchedulesUsingPUT
   */
  export interface UpdateClusterSchedulesUsingPUTParams {
    /**
     * request
     */
    request: ScheduleRequest;

    /**
     * clusterScheduleId
     */
    clusterScheduleId: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for deleteClusterScheduleUsingDELETE
   */
  export interface DeleteClusterScheduleUsingDELETEParams {
    /**
     * clusterScheduleId
     */
    clusterScheduleId: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for silenceAlertsUsingPOST
   */
  export interface SilenceAlertsUsingPOSTParams {
    /**
     * request
     */
    request: SilenceAlarmRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getTemplateInputsUsingGET
   */
  export interface GetTemplateInputsUsingGETParams {
    /**
     * inputType
     */
    inputType: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for createTemplateInputsUsingPOST
   */
  export interface CreateTemplateInputsUsingPOSTParams {
    /**
     * templateInputs
     */
    templateInputs: Array<StackTemplateInput>;

    /**
     * inputType
     */
    inputType: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getTemplateInputByUidUsingGET
   */
  export interface GetTemplateInputByUidUsingGETParams {
    /**
     * uid
     */
    uid: string;

    /**
     * inputType
     */
    inputType: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for updateTemplateInputUsingPUT
   */
  export interface UpdateTemplateInputUsingPUTParams {
    /**
     * uid
     */
    uid: string;

    /**
     * templateInput
     */
    templateInput: StackTemplateInput;

    /**
     * inputType
     */
    inputType: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for deleteTemplateInputsUsingDELETE
   */
  export interface DeleteTemplateInputsUsingDELETEParams {
    /**
     * uid
     */
    uid: string;

    /**
     * inputType
     */
    inputType: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for createClusterTFDetailsUsingPOST
   */
  export interface CreateClusterTFDetailsUsingPOSTParams {
    /**
     * tfRunConfigurations
     */
    tfRunConfigurations: TFRunConfigurations;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for updateClusterTFDetailsUsingPUT
   */
  export interface UpdateClusterTFDetailsUsingPUTParams {
    /**
     * tfRunConfigurations
     */
    tfRunConfigurations: TFRunConfigurations;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for addToolsConfigUsingPOST
   */
  export interface AddToolsConfigUsingPOSTParams {
    /**
     * toolsConfig
     */
    toolsConfig: ToolsConfig;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for editToolsConfigUsingPUT
   */
  export interface EditToolsConfigUsingPUTParams {
    /**
     * toolsConfigId
     */
    toolsConfigId: string;

    /**
     * toolsConfig
     */
    toolsConfig: ToolsConfig;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for upsertVarsUsingPOST1
   */
  export interface UpsertVarsUsingPOST1Params {
    /**
     * clusterVars
     */
    clusterVars: { [key: string]: string };

    /**
     * clusterId
     */
    clusterId: string;
  }
}

export { UiCommonClusterControllerService };
